import { IRouteConfig } from '../route.types';
import reportSgdIcon from '@app/assets/images/report-education.svg';
import DashBoard from '@modules/school-service/pages/DashboardPage';

export type { IRouteConfig };

export const baoCaoSgdModuleRoute: IRouteConfig = {
    icon: reportSgdIcon,
    name: (
        <>
            Báo cáo <br /> Sở Giáo Dục
        </>
    ),
    isMenu: false,
    isRoute: true,
    path: '/bao-cao-so-giao-duc',
    link: '/bao-cao-so-giao-duc',
    exact: true,
    isModule: true,
    themeColor: '#1abcb7',
    main: () => <DashBoard />,
    isAuth: true,
    children: [],
};
